/**
 * OVERRIDE: Edit.jsx
 * REASON: Adding BlockModelv3 wrappers
 * DATE: 2024-02-01
 * DEVELOPER: @sneridagh
 */

import Edit from '../../../../../../components/Blocks/Block/Edit';

export default Edit;
